import { Button, Chip, Paper, Stack, Typography } from '@mui/material'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import moment from 'moment'

const ObsoleteRow = ({ item, onRemove }) => {
  const detail = !item.noExpiry && item.expiryDate
    ? `Expires ${moment(item.expiryDate).format('DD/MM/YYYY')}`
    : item.noExpiry
      ? 'No expiry'
      : 'No expiry recorded'

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.default',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent="space-between"
        gap={1}
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          <Inventory2OutlinedIcon color="action" fontSize="small" />
          <Typography fontWeight={700}>{item.name}</Typography>
          {item.size && <Typography color="text.secondary">{item.size}</Typography>}
          <Chip size="small" label="No longer required" />
          <Chip size="small" variant="outlined" label={detail} />
        </Stack>
        <Button
          color="inherit"
          variant="outlined"
          onClick={() => onRemove(item)}
          size="small"
          startIcon={<DeleteOutlineIcon />}
        >
          Remove
        </Button>
      </Stack>
    </Paper>
  )
}

export default ObsoleteRow
